<template>
  <!-- DETAIL ROUTOVACI SKUPINY -->
  <div class="detail-page">
    <div :class="{ visible: isHeaderFixed }" class="detail-page__sticky-header d-flex align-items-center">
      <div class="detail-page__sticky-header__right d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-end detail-page__tabs__wrapper">
          <div :class="{ active: selectedTab === 1 }" class="detail-page__tabs__tab" @click="selectedTab = 1">
            {{ $t("vseOSkupine") }}
          </div>
          <div :class="{ active: selectedTab === 2 }" class="detail-page__tabs__tab" @click="selectedTab = 2">
            {{ $t("zarizeniVeSkupine") }}
          </div>
          <div :class="{ active: selectedTab === 3 }" class="detail-page__tabs__tab" @click="selectedTab = 3">
            {{ $t("endpointyVeSkupine") }}
          </div>
          <!--div class="detail-page__tabs__tab" @click="selectedTab = 3" v-bind:class="{'active':(selectedTab == 3)}">{{ $t("logOperaci") }}</div-->
        </div>
        <div class="d-flex align-items-center justify-content-end detail-page__sticky-header__buttons">
          <button
            class="btn btn-primary d-flex align-items-center justify-content-center"
            @click="toggleEditGroupModal('editGroup')"
          >
            <div class="atom-icon">
              <img src="@/assets/icons/actions/ico-btn-edit.svg" />
            </div>
            {{ $t("upravit") }}
          </button>
          <button
            class="btn btn-outline-primary btn-icon d-flex align-items-center justify-content-center m-0"
            @click="toggleDeleteGroup"
          >
            <div class="atom-icon m-0">
              <img src="@/assets/icons/actions/ico-ico-delete.svg" />
            </div>
          </button>
        </div>
      </div>
    </div>
    <div v-if="dataFlow" id="detail-header" class="layout__content__header layout__content__header--white">
      <AppBack :route="'/groups/' + customerId + '/' + projectId" :text="'naSeznamSkupin'" />
      <div class="d-flex align-items-end justify-content-between">
        <h1 class="layout__content__header__title">
          {{ dataFlow.deviceGroupName }}
        </h1>

        <div class="layout__content__header__buttons d-none d-md-flex align-items-center justify-content-end">
          <button
            class="btn btn-primary d-flex align-items-center justify-content-center"
            @click="toggleEditGroupModal('editGroup')"
          >
            <div class="atom-icon">
              <img src="@/assets/icons/actions/ico-btn-edit.svg" />
            </div>
            {{ $t("upravit") }}
          </button>
          <button
            class="btn btn-outline-primary btn-icon d-flex align-items-center justify-content-center m-0"
            @click="toggleDeleteGroup()"
          >
            <div class="atom-icon m-0">
              <img src="@/assets/icons/actions/ico-ico-delete.svg" />
            </div>
          </button>
        </div>

        <div
          :class="{ opened: openedDropdown }"
          class="layout__content__header__buttons--mobile d-md-none mb-4"
          @click="toggleDropdown()"
        >
          <div class="btn btn-primary d-flex align-items-center justify-content-center mt-1 mt-sm-2">
            <img class="mr-2 dropdown-actions__icon" src="@/assets/icons/actions/ico-ico-btn-akce.svg" />
            {{ $filters.firstUpper($t("akce")) }}

            <div class="dropdown-actions__wrapper">
              <div class="dropdown-actions__inner">
                <div
                  class="dropdown-actions__item d-flex align-items-center"
                  @click="toggleEditGroupModal('editGroup')"
                >
                  <div class="atom-icon">
                    <img src="@/assets/icons/actions/ico-ico-upravitzarizeni.svg" />
                  </div>
                  {{ $filters.firstUpper($t("upravit")) }}
                </div>
                <div class="dropdown-actions__item d-flex align-items-center" @click="toggleDeleteGroup()">
                  <div class="atom-icon">
                    <img src="@/assets/icons/actions/ico-ico-delete.svg" />
                  </div>
                  {{ $filters.firstUpper($t("odstranitSkupinu")) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="detail-page__info d-flex align-items-center font-weight-light flex-wrap">
        <div class="w-100">
          <span v-if="dataFlow.deviceGroupDesc" class="detail-page__info__item gray-text-light mb-1">
            {{ $filters.strLimit(dataFlow.deviceGroupDesc, 36) }}
          </span>
        </div>
      </div>
      <div v-if="dataFlow" class="detail-page__boxes d-flex flex-column flex-md-row">
        <div class="detail-page__boxes__item battery">
          <p class="label font-weight-light">
            {{ $t("pocetZarizeni") }}
          </p>
          <div class="detail-page__boxes__value d-flex align-items-center">
            <div class="detail-page__boxes__textWithIcon">
              <img
                v-if="dataFlow.devices > 0"
                class="detail-page__boxes__textWithIcon__icon"
                src="@/assets/icons/endpoint-activity/ico-ico-zarizeni.svg"
              />
              <img
                v-else
                class="detail-page__boxes__textWithIcon__icon atom-icon--muted"
                src="@/assets/icons/endpoint-activity/ico-ico-zarizeni.svg"
              />
              {{ dataFlow.devices }}
            </div>
          </div>
        </div>
        <div class="detail-page__boxes__item">
          <p class="label font-weight-light">
            {{ $t("pocetEndpointu") }}
          </p>
          <div class="detail-page__boxes__value d-flex align-items-center">
            <div class="detail-page__boxes__textWithIcon">
              <img
                v-if="dataFlow.endpoints > 0"
                class="detail-page__boxes__textWithIcon__icon"
                src="@/assets/icons/endpoint-activity/ico-menu-endpointy-green.svg"
              />
              <img
                v-else
                class="detail-page__boxes__textWithIcon__icon atom-icon--muted"
                src="@/assets/icons/endpoint-activity/ico-menu-endpointy-green.svg"
              />
              {{ dataFlow.endpoints }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="dataFlow" class="detail-page__tags d-flex align-items-center font-weight-light">
        <div v-if="tagsToShow.length" class="d-flex">
          {{ $t("tagy") }}
          <div class="ml-2 mr-4 d-flex align-items-center">
            <!--a href="#" class="atom-tag">Vodoměry</a><a href="#" class="atom-tag">Klient 1</a><a href="#" class="atom-tag">Klient 2</a-->
            <div v-for="tag in tagsToShow" :key="tag" class="">
              <a class="atom-tag" href="#">
                <span>{{ $filters.strLimit(tag, 11) }}</span>
              </a>
            </div>
          </div>
        </div>
        <div v-if="dataFlow.attributes" class="d-flex">
          {{ $t("parametry") }}
          <div class="ml-2 mr-4 d-flex align-items-center">
            <div v-for="(value, name) in dataFlow.attributes" :key="name" class="">
              <a class="atom-tag" href="#">
                <span>{{ name }}: {{ $filters.strLimit(value, 11) }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!--div v-if="selectedTab == 1">
        <radio-help :slides="helpSlides" :show="showHelp" @updateShow="showValue" />
      </div-->
      <div v-if="selectedTab === 1">
        <RadioHelp
          :article-link="'/skupina/informace'"
          :show="showHelp"
          @change-radio-btn-visibility="changeRadioBtnVisibility($event)"
          @update-show-radio-help="showRadioHelp($event)"
        />
      </div>
      <div v-if="selectedTab === 2">
        <RadioHelp
          :article-link="'/skupina/zarizeni'"
          :show="showHelp"
          @change-radio-btn-visibility="changeRadioBtnVisibility($event)"
          @update-show-radio-help="showRadioHelp($event)"
        />
      </div>
      <div v-if="selectedTab === 3">
        <RadioHelp
          :article-link="'/skupina/vystupy'"
          :show="showHelp"
          @change-radio-btn-visibility="changeRadioBtnVisibility($event)"
          @update-show-radio-help="showRadioHelp($event)"
        />
      </div>
    </div>

    <div class="layout__content__content pt-0 px-0">
      <div id="tabs" class="detail-page__tabs">
        <div class="detail-page__tabs__header d-flex">
          <div class="d-flex align-items-end detail-page__tabs__wrapper">
            <div :class="{ active: selectedTab === 1 }" class="detail-page__tabs__tab" @click="selectedTab = 1">
              {{ $t("vseOSkupine") }}
            </div>
            <div :class="{ active: selectedTab === 2 }" class="detail-page__tabs__tab" @click="selectedTab = 2">
              {{ $t("zarizeniVeSkupine") }}
            </div>
            <div :class="{ active: selectedTab === 3 }" class="detail-page__tabs__tab" @click="selectedTab = 3">
              {{ $t("endpointyVeSkupine") }}
            </div>
            <RadioOpenClose
              :radio-slides="radioSlides"
              :show="showHelp"
              @update-show-radio-help="showRadioHelp($event)"
            />
          </div>
        </div>
        <div class="group-tabs detail-page__tabs__content">
          <div v-show="selectedTab === 1">
            <data-flow-diagram
              v-if="project?.projectId"
              :initial-data-flow="dataFlowForDiagram"
              :is-save-modal-opened="false"
              readonly-technology
              use-own-save-btn
              @updated="loadGroup"
            />
          </div>
          <div v-show="selectedTab === 2">
            <devices-table :group="dataFlow" :selectable="true" />
          </div>
          <div v-show="selectedTab === 3">
            <EndpointsTable
              :key="endpointTableKey"
              :all-endpoints="groupsEndpoints"
              :group="dataFlow"
              :selectable="true"
            />
          </div>
        </div>
      </div>
    </div>
    <EditGroupModal
      :device="dataFlow"
      :opened="openedEditGroup"
      @close-box="toggleEditGroupModal"
      @open-box="toggleEditGroupModal"
      @reload-items="loadGroup"
    />

    <DeleteGroupModal
      :centered="true"
      :items="[dataFlow]"
      :opened="openedDeleteGroup"
      :text="''"
      @close="toggleDeleteGroup()"
      @yes="
        () => {
          deleteGroup()
          toggleDeleteGroup()
        }
      "
    />
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="openedError = false" />
    </div>
  </div>
</template>

<script>
import axios from "axios"
import Back from "@/components/back.vue"
import RadioHelp from "@/components/radio/radio-help.vue"
import RadioOpenClose from "@/components/radio/radio-open-close.vue"
import EditGroupModal from "@/components/modals/groups/edit.vue"
import DeleteGroupModal from "@/components/confirmations/delete.vue"
import EndpointsTable from "@/components/groups/endpointsTable.vue"
import DevicesTable from "@/components/groups/devicesTable.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import DataFlowDiagram from "@/components/groups/diagram/DataFlowDiagram.vue"
import { useProjectStore } from "@/store/modules/project"
import { useConfigStore } from "@/store/modules/config"
import { useEndpointsStore } from "@/store/modules/endpoints"

export default {
  components: {
    DataFlowDiagram,
    EditGroupModal,
    AppBack: Back,
    RadioHelp,
    RadioOpenClose,
    DeleteGroupModal,
    EndpointsTable,
    DevicesTable,
    ErrorModal
  },
  props: {
    projectId: String,
    customerId: String,
    tab: String
  },
  setup() {
    const projectStore = useProjectStore()
    const configStore = useConfigStore()
    const endpointsStore = useEndpointsStore()

    return { projectStore, configStore, endpointsStore }
  },
  data() {
    return {
      radioSlides: [],
      search: "",
      showHelp: true,
      deviceId: this.$route.params.id,
      dataFlow: {},
      rowsPerPage: 20,
      page: 0,
      groups: [],
      groupsGroups: [],
      signal: 2,
      selectedTab: 1,
      service: {},
      sortGroups: "desc",
      openedGroups: [],
      openedGroup: {},
      openedGroupTags: [],
      openedDropdown: false,
      isHeaderFixed: false,
      isTableHeaderFixed: false,
      openedMessageDetail: [],
      selectedMessage: {},
      allLogs: [
        {
          code: "Editace zařízení",
          level: "",
          timespamp: "2020-03-12T12:33:23.000Z",
          originator: "karel.vochechule@email.muj",
          parameters: {
            userName: "Karel Vochechule"
          }
        },
        {
          code: "Konfigurační zpráva",
          level: "Ve frontě",
          timespamp: "2020-03-12T12:33:23.000Z",
          originator: "jan.pavlasek@email.muj",
          parameters: {
            userName: "Jan Pavlásek"
          }
        },
        {
          code: "Vytvoření zařízení",
          level: "Ve frontě",
          timespamp: "2020-03-12T12:33:23.000Z",
          originator: "mirek@email.muj",
          parameters: {
            userName: "Mirek Dušín"
          }
        }
      ],
      allMessages: [],
      helpSlides: [],
      openedEditGroup: [],
      openedPingGroup: false,
      pingResponses: [],
      toDelete: [],
      openedDeleteGroup: false,
      deleteText: "",
      groupsDevicesOpened: false,
      errorsToTranslate: [],
      openedError: false,
      endpointTableKey: 0,
      groupDevices: [],
      groupsEndpoints: [],
      endpointsLoaded: false
    }
  },
  computed: {
    id() {
      return parseInt(this.$route.params.id)
    },
    dataFlowForDiagram() {
      if (!this.dataFlow.technology || !this.endpointsLoaded) return
      return {
        ...this.dataFlow,
        endpoints: this.groupsEndpoints,
        hardwareId: null
      }
    },
    locale() {
      return this.$i18n.locale
    },
    project() {
      return this.projectStore.selectedProject
    },
    radioDisabled() {
      return this.configStore.isRadioHelpDisabled
    },
    tagsToShow() {
      return this.dataFlow.tags?.filter((t) => !t.startsWith("hidden_")) || []
    }
  },
  watch: {
    async project(project, oldProject) {
      if (project?.projectId === oldProject?.projectId) {
        return
      }

      if (this.dataFlow?.projectId) {
        if (this.project.projectId === this.dataFlow.projectId) {
          await this.endpointsStore.getAllEndpoints({
            sort: "custDestId",
            rowsPerPage: 1000,
            currentPage: 0
          })
          await this.endpointsStore.getMqttGateways({
            sort: "custDestId",
            rowsPerPage: 1000,
            currentPage: 0
          })
          this.groupsEndpoints = this.endpointsStore.allEndpointsForReal.filter((end) =>
            end.deviceGroups.some((dg) => dg.deviceGroupId === this.id)
          )
          this.endpointsLoaded = true
        } else {
          /** redirect to all lora devices if current project differs from new selected */
          this.$router.push({
            name: "groups",
            customerId: this.$route.params.customerId,
            projectId: this.project.projectId
          })
        }
      }
    },
    async dataFlow() {
      if (this.project) {
        await this.endpointsStore.getAllEndpoints({
          sort: "custDestId",
          rowsPerPage: 1000,
          currentPage: 0
        })
        await this.endpointsStore.getMqttGateways({
          sort: "custDestId",
          rowsPerPage: 1000,
          currentPage: 0
        })
        this.groupsEndpoints = this.endpointsStore.allEndpointsForReal.filter((end) =>
          end.deviceGroups.some((dg) => dg.deviceGroupId === this.id)
        )
        this.endpointsLoaded = true
      }
    },
    radioDisabled: {
      handler() {
        this.showHelp = !this.radioDisabled
      },
      immediate: true
    }
  },
  mounted() {
    if (this.tab) {
      this.selectedTab = parseInt(this.tab)
    }

    this.loadGroup()

    const tabsElement = document.getElementById("tabs")
    window.document.onscroll = () => {
      if (tabsElement) {
        this.isHeaderFixed = window.scrollY > tabsElement.offsetTop + 250
      }
    }
  },
  unmounted() {
    window.document.onscroll = undefined
  },
  methods: {
    changeRadioBtnVisibility(radioSlides) {
      this.radioSlides = radioSlides
    },
    showRadioHelp(status) {
      this.showHelp = status
    },
    /** load group data */
    loadGroup() {
      axios
        .get(`${process.env.VUE_APP_API}/device-groups/${this.$route.params.id}`, {})
        .then((result) => {
          this.dataFlow = result.data.data
          this.endpointTableKey += 1
        })
        .catch(() => {})
    },
    toggleDropdown() {
      this.openedDropdown = !this.openedDropdown
    },

    copyToClipboard(text) {
      var input = document.createElement("textarea")
      input.innerHTML = text
      document.body.appendChild(input)
      input.select()
      var result = document.execCommand("copy")
      document.body.removeChild(input)
      return result
    },

    searchGroups(search) {
      this.filterGroups(search)
    },

    toggleEditGroupModal(box) {
      if (this.openedEditGroup.indexOf(box) > -1) {
        box == undefined
          ? (this.openedEditGroup = [])
          : this.openedEditGroup.splice(this.openedEditGroup.indexOf(box), 1)
      } else {
        this.openedEditGroup.push(box)
      }
    },

    toggleDeleteGroup() {
      if (this.openedDeleteGroup == true) {
        this.openedDeleteGroup = false
        this.deleteText = ""
      } else {
        this.deleteText = ""
        this.openedDeleteGroup = true
      }
    },
    deleteGroup() {
      let id = this.dataFlow.deviceGroupId
      let notifications = []
      this.errorsToTranslate = []
      axios
        .delete(process.env.VUE_APP_API + "/device-groups/" + id, {})
        .then((response) => {
          if (response.status === 204) {
            notifications.push({
              text: "notificationGroupDelete",
              error: false,
              params: {
                deviceGroupId: this.dataFlow.deviceGroupId,
                deviceGroupName: this.dataFlow.deviceGroupName
              }
            })
            this.$router.push({
              name: "groups",
              params: {
                customerId: this.customerId,
                projectId: this.projectId,
                notifications: notifications
              }
            })
          }
        })
        .catch((error) => {
          let message = error.data.errors[0]
          error.data.errors = []
          error.data.errors.push({
            message: message,
            attribute: {
              deviceGroupName: this.dataFlow.deviceGroupName,
              deviceGroupId: this.dataFlow.deviceGroupId
            }
          })
          this.errorsToTranslate.push(error.data)
          this.openedError = true
        })
    },
    toggleShowMessage(box) {
      if (this.openedMessageDetail.indexOf(box) > -1) {
        box == undefined
          ? (this.openedMessageDetail = [])
          : this.openedMessageDetail.splice(this.openedMessageDetail.indexOf(box), 1)
      } else {
        this.openedMessageDetail.push(box)
      }
    },
    showMessage(message) {
      message.messageTime = message.requestTime
      this.selectedMessage = message
      this.openedMessageDetail.push("showMessage")
    }
  }
}
</script>

<style scoped></style>
